function MTMR_TGR(ths){
  var clss = document.getElementsByClassName("mtmr-inpt");
  clss = [].slice.call( clss );
  var cl = clss.indexOf(ths)
  var cld = document.getElementsByClassName("mtmr-ul")[cl];
  cld.classList.toggle('mtr-open');
  /* ----------- bottomのcheck欄に商品種のみ記述 ---------------- */
  var ths_chk = ths.checked;
  var Prd_Name1 = ths.id;
  var Prd_Name2 = Prd_Name1.replace("properties[","");
  var Prd_Name2 = Prd_Name2.replace("]","");
  if(ths_chk==true){
    var Prd_div = document.createElement("div");
    Prd_div.id = "bottom-chk[" + Prd_Name2 + "]";
    Prd_div.className = "bottom-chk_list";
    var Prd_Name2 = Prd_Name2.replace("-","");
    Prd_div.textContent = "・" + Prd_Name2;
    document.getElementById("Btn-select_prd_detail_text").appendChild(Prd_div);
  }else{
    document.getElementById("bottom-chk[" + Prd_Name2 + "]").remove();
  };
  /* ----------- bottomのcheck欄に商品種のみ記述 ---------------- */
};

function OpnHtuse(Top){
  document.getElementById("Htuse-mtmr_top").classList.toggle('mtr-open');
  Top.classList.toggle('opn');
};

function add_snt_rw(TsT){
  var snt_id = document.getElementsByClassName("mtmr-snt");
  var snt_L = snt_id.length;
  var nsn = snt_L + 1;
  var Nme = "その他家電-" + nsn;
  var Brnk = document.createElement("br");
  var D1 = document.createElement("div");
  D1.className = "mtmr-cont";
  D1.id = "mtmr-snt" + nsn;
  D1.classList.add("mtmr-snt");
  TsT.before(D1);
  var I1 = document.createElement("input");
  I1.id = "properties[" + Nme + "]";
  I1.className = "mtmr-inpt";
  I1.setAttribute("type","checkbox");
  I1.name = "contact[" + Nme + "]";
  I1.setAttribute("onclick","MTMR_TGR(this)");
  D1.appendChild(I1);
  var L1 = document.createElement("label");
  L1.setAttribute("for","properties[" + Nme + "]");
  L1.textContent = "その他家電 " + nsn + " ";
  D1.appendChild(L1);
  var R1 = document.createElement("span");
  R1.textContent = "削除";
  R1.className = "mtmr-rmv";
  R1.setAttribute("onclick","SKJ(this)");
  L1.after(R1);
  R1.after(Brnk);
  var D2 = document.createElement("div");
  D2.className = "mtmr-ul";
  D1.appendChild(D2);
  var D3 = document.createElement("div");
  D3.className = "mtmr-li";
  D2.appendChild(D3);
    for(var a = 1;a < 6; a++){
      var D4_1 = document.createElement("div");
      D4_1.className = "mtmr-lai";
      D3.appendChild(D4_1);
      var L2_1 = document.createElement("label");
      if(a == 1){var Nme_in = "[" + Nme + "：商品名]";var CNme = "・商品名　";var PH = "例：ロボット掃除機";}
      else if(a == 2){var Nme_in = "[" + Nme + "：型番]";var CNme = "・型番　";var PH = "例：NW-SP10-B";}
      else if(a == 3){var Nme_in = "[" + Nme + "：サイズ]";var CNme = "・サイズ　";var PH = "例：5L";}
      else if(a == 4){var Nme_in = "[" + Nme + "：機能]";var CNme = "・機能　";var PH = "例：拭き掃除機能";}
      else if(a == 5){var Nme_in = "[" + Nme + "：その他]";var CNme = "・その他　";var PH = "例：色・メーカーなど自由記述";};
      L2_1.setAttribute("for","properties" + Nme_in);
      L2_1.textContent = CNme;
      D4_1.appendChild(L2_1);
      var D4_2 = document.createElement("div");
      D4_2.className = "mtmr-iput";
      D4_1.appendChild(D4_2);
      if(a < 4){
        var I2 = document.createElement("input");
        I2.id = "properties" + Nme_in;
        I2.setAttribute("type","text");
        I2.name = "contact" + Nme_in;
        I2.setAttribute("placeholder",PH);
        D4_2.appendChild(I2);
      }else{
        var T1 = document.createElement("textarea");
        T1.id = "properties" + Nme_in;
        T1.setAttribute("type","text");
        T1.name = "contact" + Nme_in;
        T1.setAttribute("placeholder",PH);
        T1.setAttribute("rows","5");
        T1.setAttribute("wrap","soft");
        D4_2.appendChild(T1);
        D4_2.classList.add("sp");
      };
      var H1 = document.createElement("hr");
      H1.className = "mtmr-hr";
      D4_1.after(H1);
    };
};

function SKJ(Ts){
  var PRNT = Ts.parentElement;
  PRNT.remove();
};

function FRM_Check(CKval){
  document.getElementById("MTMR-Bottom_chk").classList.toggle('mtr-open');
  if(CKval==1){
    /*  チェックボックスtoggleで下部にチェック済みの商品リストが出現するが、以下でその他家電の場合は商品名を取得して表示（inputがカラの場合はそのまま）  */
    var c_Len = document.getElementsByClassName("bottom-chk_list").length;
    for(var b = 0;b < c_Len; b++){
      var c_ID = document.getElementsByClassName("bottom-chk_list")[b].id;
      var c_ID_ido = c_ID.indexOf("その他家電");
      if(c_ID_ido > 0){
        var PrdNameBtm = c_ID.replace("bottom-chk[","");
        var PrdNameBtm = PrdNameBtm.replace("]","");
        var Prd_ID_btm = "properties[" + PrdNameBtm + "：商品名]";
        var Prd_KTBN_btm = "properties[" + PrdNameBtm + "：型番]";
        var PrdNameBtm2 = document.getElementById(Prd_ID_btm).value;
        var KTBNBtm2 = document.getElementById(Prd_KTBN_btm).value;
        var ItemNameBtm = document.getElementsByClassName("bottom-chk_list")[b].textContent;
        if(PrdNameBtm2!=""){
          var txtCnts = ItemNameBtm + "：" + PrdNameBtm2;
          document.getElementsByClassName("bottom-chk_list")[b].textContent = txtCnts;
        }else if(KTBNBtm2!=""){
          var txtCnts = ItemNameBtm + "：" + KTBNBtm2;
          document.getElementsByClassName("bottom-chk_list")[b].textContent = txtCnts;
        };
      };
    };
  }else if(CKval==3){
    document.getElementById("R-Btn-Hid").disabled = false;
    document.getElementById("R-Btn-Hid").click();
  };
};